// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { getContentPanelsQuery } from './content-panels';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { getEcosystemQuery, getLegacyRightWebPanelsQuery } from './ecosystem';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { getIsArchivedQuery } from './lifecycle-state';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as getActivitySortOrder } from './activity-sort-order';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as getAttachmentsQuery } from './attachments';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as getCommentsQuery } from './comments';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as getWorklogsQuery } from './worklogs';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { getJiraSettingsQuery } from './jira-settings';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as getMediaContextQuery } from './media-context';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as getPermissionsQuery } from './permissions';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as getProject } from './project';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { getContainersByTypeQuery } from './layout';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { getRemoteLinksQuery } from './remote-links';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as getIssueKeyQuery } from './issue-key';

export const NUM_INITIAL_COMMENTS_TO_LOAD = 5;
export const CREATED_ORDER_DESCENDING = '-created';

export const NUM_INITIAL_WORKLOGS_TO_LOAD = 5;
export const STARTED_ORDER_DESCENDING = '-started';

/**
 * GrqphQL template literal tag similar to `graphql-tag`'s `gql` function
 * which tells `eslint-plugin-graphql` to validate the Gira query string.
 *
 * For more information see the [GraphQL playbook](https://hello.atlassian.net/wiki/spaces/JFP/pages/1889693782/Jira+Playbook+Graphql).
 *
 * This function itself does nothing but merge the string back together to
 * a normal string.
 *
 * */
export const gqlTagGira = (
	literals: TemplateStringsArray,
	...substitutions: ReadonlyArray<string | number>
): string => {
	let result = '';

	// run the loop only for the substitution count
	substitutions.forEach((key, i) => {
		result += literals[i];
		result += key.toString();
	});

	// add the last literal
	result += literals[literals.length - 1];

	return result;
};
